import React from 'react';
import * as R from 'ramda';
// components
import OverLoader from '../../../components/local-loader/over-loader';
// helpers/constants
import * as G from '../../../helpers';
// ui
import { Box, Flex } from '../../../ui';
// icons
import * as I from '../../../svgs';
// features dashboards
import { calculatePercentageChange } from '../helpers';
//////////////////////////////////////////////////

const Description = (props) => {
  const { total, prevTotal, description, withoutPercentage, revertLowPercentageTextColor } = props;

  if (G.isNilOrEmpty(description)) {
    return (
      <Flex>
        <Box
          fontSize={14}
          color='dark.mainDark'
        >
          -
        </Box>
      </Flex>
    );
  }

  if (G.isTrue(withoutPercentage)) {
    return (
      <Flex>
        <Box
          fontSize={14}
          color='dark.mainDark'
        >
          {description}
        </Box>
      </Flex>
    );
  }

  const percentage = calculatePercentageChange(total, prevTotal);

  if (R.equals(percentage, 'N/A')) {
    return (
      <Flex>
        <Box
          fontSize={14}
          color='dark.mainDark'
        >
          {`N/A ${description}`}
        </Box>
      </Flex>
    );
  }

  if (R.gt(percentage, 0)) {
    return (
      <Flex>
        <Box>{I.trendingUp()}</Box>
        <Box
          mx='5px'
          fontSize={14}
          color='softGreen'
        >
          {`${percentage}%`}
        </Box>
        <Box
          fontSize={14}
          textWrap='pretty'
          textAlign='center'
          color='dark.mainDark'
        >
          {description}
        </Box>
      </Flex>
    );
  }

  if (R.lt(percentage, 0)) {
    const percentageColor = revertLowPercentageTextColor ? 'softGreen' : 'darkRed2';

    return (
      <Flex>
        <Box>{I.trendingDown()}</Box>
        <Box
          mx='5px'
          fontSize={14}
          color={percentageColor}
        >
          {`${percentage}%`}
        </Box>
        <Box
          fontSize={14}
          textWrap='pretty'
          textAlign='center'
          color='dark.mainDark'
        >
          {description}
        </Box>
      </Flex>
    );
  }

  return (
    <Box
      fontSize={14}
      textWrap='pretty'
      textAlign='center'
      color='dark.mainDark'
    >
      {description}
    </Box>
  );
};

const TotalCard = (props) => {
  const {
    title,
    total,
    loading,
    mr = 20,
    prevTotal,
    boxShadow,
    formatter,
    totalPrefix,
    totalSuffix,
    description,
    width = 250,
    withoutPercentage,
    revertLowPercentageTextColor,
  } = props;

  const formatted = G.isFunction(formatter) ? formatter(total) : G.toLocaleString(total);

  return (
    <OverLoader mr={mr} width={width} height={120} borderRadius='10px' loaderOpen={loading}>
      <Flex
        p={15}
        bg='white'
        height={120}
        width={width}
        borderRadius={10}
        alignItems='center'
        boxShadow={boxShadow}
        flexDirection='column'
        justifyContent='space-between'
      >
        <Box
          fontSize={14}
          color='titleGrey2'
        >
          {title}
        </Box>
        <Box
          fontSize={20}
          fontWeight='bold'
          textAlign='center'
          color='dark.mainDark'
        >
          {totalPrefix} {formatted} {totalSuffix}
        </Box>
        <Description
          total={total}
          prevTotal={prevTotal}
          description={description}
          withoutPercentage={withoutPercentage}
          revertLowPercentageTextColor={revertLowPercentageTextColor}
        />
      </Flex>
    </OverLoader>
  );
};

export default TotalCard;
